/** When your routing table is too long, you can split it into small modules**/
import Layout from '@/layout';

const transactionsRoutes = {
  path: '/transactions',
  component: Layout,
  redirect: '/transactions/list',
  name: 'Transactions',
  alwaysShow: true,
  meta: {
    title: 'Płatności',
    icon: 'el-icon-money',
    permissions: ['view menu administrator'],
  },
  children: [
    {
      path: 'list',
      component: () => import('@/views/transactions/List'),
      name: 'TransactionsList',
      meta: { title: 'Lista płatności', noCache: true, icon: 'el-icon-money', permissions: ['admin offers index'] },
    },
  ],
};

export default transactionsRoutes;
